import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import DSPopper from '@elliemae/ds-basic/Popper';
import { Picker, PickerPropsTypes } from './DatePickerPicker/DatePickerPicker.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-basic/Icon';
import '@elliemae/ds-icons/DatePicker';
import '@elliemae/ds-basic/Button';
import '../prop-types-8c5debac.js';

var _convertPropToCssClas = convertPropToCssClassName('datepicker-range'),
    classNameElement = _convertPropToCssClas.classNameElement;

var noop = function noop() {
  return null;
};

function DatePickerDropdown(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      readOnly = _ref.readOnly,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      isOpen = _ref.isOpen,
      menu = _ref.menu,
      zIndex = _ref.zIndex,
      pickerProps = _ref.pickerProps,
      pickerRef = _ref.pickerRef;
  return /*#__PURE__*/React.createElement(DSPopper, {
    contentComponent: menu,
    isOpen: isOpen,
    modifiers: {
      preventOverflow: {
        enabled: true,
        padding: 0,
        boundariesElement: 'window'
      }
    },
    showArrow: false,
    triggerComponent: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Picker, _extends({
      innerRef: pickerRef
    }, pickerProps, {
      className: classNameElement('picker'),
      disabled: disabled,
      onClick: onClick,
      readOnly: readOnly
    }))),
    zIndex: zIndex
  });
}

DatePickerDropdown.propTypes = {
  pickerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  menu: PropTypes.element,
  zIndex: PropTypes.number,
  pickerProps: PropTypes.shape(PickerPropsTypes)
};

export default DatePickerDropdown;
//# sourceMappingURL=DatePickerDropdown.js.map
